import { Heading, Paragraph } from 'component-library';
import { useTranslation } from 'react-i18next';
import { getArticleDataBySubscriptionType, formatNumberToCurrency } from '@sr/utils';
import { type Country } from '@sr/types';
import { Divider, Label, OrderDetailsValue, OrderSummaryDetailsContainer } from '../styles';

type SubscriptionType = 'CO2' | 'CSRD_PREMIUM';

type OrderSummaryProps = {
  country: Country;
  type: SubscriptionType;
};

const OrderSummary: React.FC<OrderSummaryProps> = ({ country, type }) => {
  const { t } = useTranslation('');

  const { pricePerYear, vat, currency } = getArticleDataBySubscriptionType(type, country);

  const price = pricePerYear;
  const vatAmount = price * vat;
  const typePrefix = type === 'CO2' ? 'co2' : 'csrd.premium';

  return (
    <>
      <Heading variant="sCaps" as="h2" mb="24px">
        {t('summary.title')}
      </Heading>
      <Heading variant="small" as="h3" mb="32px">
        {t(`${typePrefix}.summary.subtitle`)}
      </Heading>
      <OrderSummaryDetailsContainer>
        <Label>{t('confirmation.price')}</Label>
        <OrderDetailsValue>{formatNumberToCurrency(price, currency)}</OrderDetailsValue>
      </OrderSummaryDetailsContainer>
      <OrderSummaryDetailsContainer>
        <Label>{t(`confirmation.vat`)}</Label>
        <OrderDetailsValue>
          {formatNumberToCurrency(vatAmount.toFixed(2), currency)}
        </OrderDetailsValue>
      </OrderSummaryDetailsContainer>
      <Divider />
      <OrderSummaryDetailsContainer>
        <Label>
          <b>{t('confirmation.total')}</b>
        </Label>
        <OrderDetailsValue>
          <b>{formatNumberToCurrency((price + vatAmount).toFixed(2), currency)}</b>
        </OrderDetailsValue>
      </OrderSummaryDetailsContainer>
      <Paragraph variant="medium">{t('summary.subtext.annually')}</Paragraph>
    </>
  );
};

export default OrderSummary;
